import React from 'react'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import MonthlyStatement from './monthly-statement'
export default function LastThreeMonthStatement() {
    return (
        <div>
            <LayoutWithAccountCard breadCumKey='LAST_THREE_MONTH'>
           <MonthlyStatement month="3"/>
            </LayoutWithAccountCard> 
        </div>
    )
}
